import { Component, OnInit } from '@angular/core';
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {PedidosService} from "../../services/pedidos.service";
import {ModalKendo} from "../../lib/ModalKendo";

@Component({
  selector: 'app-modal-deliverydetalhes',
  templateUrl: './modal-deliverydetalhes.component.html',
  styleUrls: ['./modal-deliverydetalhes.component.scss']
})
export class ModalDeliverydetalhesComponent extends ModalKendo implements OnInit {
  notificacoes: any =  [];
  pedido: any = {};
  modoGrupoLojas = false;
  eventos = [];
  carregando = true;
  constructor( private  grupolojasService: GrupolojasService,
              private  pedidosService: PedidosService) {
    super()
  }


  ngOnInit(): void {
    const requisicao = this.modoGrupoLojas
      ? this.grupolojasService.listeNotificacaoesLogiscaDoPedido(this.pedido)
      : this.pedidosService.listeNotificacaoesLogiscaDoPedido(this.pedido.id);

    requisicao.then((notificacoes) => {
      this.carregando = false;
      this.notificacoes = notificacoes;
    }).catch((erro) => {
      this.carregando = false;
      alert(erro);
    })
  }

}
